import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../common/api";

export const sendContactForm = createAsyncThunk(
  "contact/sendContactForm",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post("/Home/contact", formData);
      if (response.data.success) {
        return response.data.message;
      } else {
        return rejectWithValue(response.data.errors || response.data.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.errors || error.message);
    }
  }
);

const contactSlice = createSlice({
  name: "contact",
  initialState: {
    formData: {
      name: "",
      email: "",
      phoneNumber: "",
      subject: "",
      message: "",
    },
    errors: {}, // برای نگهداری خطاهای هر فیلد
    status: "idle",
    error: null,
    successMessage: null,
  },
  reducers: {
    updateFormData: (state, action) => {
      state.formData[action.payload.field] = action.payload.value;
      state.errors[action.payload.field] = ""; // حذف خطا در هنگام تغییر مقدار
    },
    resetForm: (state) => {
      state.formData = {
        name: "",
        email: "",
        phoneNumber: "",
        subject: "",
        message: "",
      };
      state.errors = {};
      state.successMessage = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendContactForm.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.successMessage = null;
      })
      .addCase(sendContactForm.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.successMessage = action.payload;
        state.errors = {};
      })
      .addCase(sendContactForm.rejected, (state, action) => {
        state.status = "failed";
        if (typeof action.payload === "object") {
          state.errors = action.payload; // خطاهای اعتبارسنجی سرور
        } else {
          state.error = action.payload; // خطای کلی
        }
      });
  },
});

export const { updateFormData, resetForm } = contactSlice.actions;
export default contactSlice.reducer;
